import { serverCodeOf } from "./handled-error"

export const APP_AUDIENCE_DENIED = "app_audience_denied"

export const isAppAudienceDenied = (data: unknown): boolean =>
  serverCodeOf(data) === APP_AUDIENCE_DENIED
